import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { KeywordService } from '@services/keyword.service';
import { ToastrService } from 'ngx-toastr';
import html2canvas from 'html2canvas';

interface CardLanguage {
  code: string;
  label: string;
}

interface CardStyle {
  key: string;
  name: string;
}

const CARD_WIDTH = 1080;
const CARD_HEIGHT = 1920;

@Component({
  selector: 'app-social-card',
  templateUrl: './social-card.component.html',
  styleUrls: ['./social-card.component.css']
})
export class SocialCardComponent implements OnChanges {

  @Input() keyword: any;
  @ViewChild('exportCard', { static: false }) exportCard: ElementRef<HTMLElement>;

  languages: CardLanguage[] = [
    { code: 'en-US', label: 'ENGLISH' },
    { code: 'de-DE', label: 'DEUTSCH' },
    { code: 'es-ES', label: 'ESPAÑOL' },
    { code: 'fr-FR', label: 'FRANÇAIS' }
  ];

  styles: CardStyle[] = [
    { key: 'a', name: 'Gece Teal' },
    { key: 'b', name: 'Fildişi Premium' },
    { key: 'c', name: 'Marka Gradyan' }
  ];

  selectedStyle = 'a';
  translations: { [code: string]: string } = {};
  loading = false;
  generating = false;

  constructor(
    private keywordService: KeywordService,
    private toastr: ToastrService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.keyword && this.keyword?.id) {
      this.loadTranslations();
    }
  }

  get hasTranslations(): boolean {
    return Object.keys(this.translations).length > 0;
  }

  wordFor(code: string): string {
    return this.translations[code];
  }

  loadTranslations(): void {
    if (!this.keyword?.id) {
      return;
    }
    this.loading = true;
    this.keywordService.getTranslations(this.keyword.id).subscribe(res => {
      this.translations = res?.translations || {};
      this.loading = false;
    }, () => {
      this.loading = false;
      this.toastr.clear();
      this.toastr.error('Çeviriler alınırken bir hata oluştu', 'Hata');
    });
  }

  download(): void {
    if (!this.exportCard || !this.hasTranslations) {
      return;
    }
    this.generating = true;
    html2canvas(this.exportCard.nativeElement, {
      width: CARD_WIDTH,
      height: CARD_HEIGHT,
      scale: 1,
      useCORS: true,
      backgroundColor: null
    }).then(canvas => {
      const link = document.createElement('a');
      const code = this.keyword?.code || this.keyword?.id || 'kelime';
      link.download = `gunun-kelimesi-${code}-${this.selectedStyle}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
      this.generating = false;
    }).catch(() => {
      this.generating = false;
      this.toastr.clear();
      this.toastr.error('Görsel oluşturulurken bir hata oluştu', 'Hata');
    });
  }
}
